import catalog from '../data/professions.json';

// Référentiel ROME embarqué : disponible dès l'ouverture, même sans API.
// Pour modifier la liste, mettre à jour src/data/professions.json.
const qualifications = catalog.professions.map(({ libelle }) => libelle);

export default qualifications;
